import { useEffect, useState } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { get } from 'lodash';

export const useCustomDetailDefinitionRowController = (
	onRemoveClicked: () => void,
	index: number
) => {
	const [isEdit, setIsEdit] = useState(false);
	const nameKey = `customDefinitions.${index}.name`;
	const instructionKey = `customDefinitions.${index}.instruction`;
	const [originalNameValue, setOriginalNameValue] = useState('');
	const [originalInstructionValue, setOriginalInstructionValue] = useState('');

	const methods = useFormContext();
	methods.watch();
	const nameValue = methods.getValues(nameKey);
	const instructionValue = methods.getValues(instructionKey);
	const { errors } = useFormState();
	const isInvalid = !!get(errors, nameKey);

	const onSaveButtonClicked = async () => {
		const isValid = await methods.trigger(nameKey);
		if (!isValid) {
			return;
		}
		setIsEdit(false);
	};
	const onCloseButtonClicked = () => {
		if (originalNameValue === '') {
			onRemoveClicked();
		} else {
			methods.setValue(nameKey, originalNameValue ?? '');
			methods.setValue(instructionKey, originalInstructionValue ?? '');
			setIsEdit(false);
		}
	};
	const onEditButtonClicked = () => {
		setOriginalNameValue(nameValue);
		setOriginalInstructionValue(instructionValue);
		setIsEdit(true);
	};

	useEffect(() => {
		if (!nameValue && !isEdit) {
			setIsEdit(true);
		} else {
			setOriginalNameValue(nameValue);
			setOriginalInstructionValue(instructionValue);
		}
	}, []);

	return {
		isInvalid,
		isEdit,
		nameKey,
		nameValue,
		instructionKey,
		instructionValue,
		onSaveButtonClicked,
		onCloseButtonClicked,
		onEditButtonClicked,
	};
};
